<h1 matDialogTitle>{{ 'CAMPAIGN_RESULT.APPROVE_TITLE' | translate }}</h1>
<div mat-dialog-content>
    <p class="text-center">{{ 'CAMPAIGN_RESULT.APPROVE_DESC' | translate }}</p>
    <table id="result-confirm-dialog">
        <tr>
            <td style="width: 130px">{{ 'CAMPAIGN_RESULT.OFFICIAL_RECRUIT' | translate }}</td>
            <td style="width: 200px">{{countOfficial}}</td>
        </tr>
        <tr>
            <td>{{ 'CAMPAIGN_RESULT.BACKUP_RECRUIT' | translate }}</td>
            <td>{{countBackup}}</td>
        </tr>
<!--        <tr>-->
<!--            <td>Thời hạn xác nhận đi làm</td>-->
<!--            <td>{{acceptingDeadline}}</td>-->
<!--        </tr>-->
        <tr>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td>{{ 'CAMPAIGN_RESULT.REVIEWER_LABEL' | translate }}</td>
            <td>
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-select [(ngModel)]="reviewerId">
                        <mat-option
                            *ngFor="let member of reviewerList"
                            [value]="member.id + ''"
                        >
                            {{ getFullNamAndEmail(member) }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td>{{ 'CAMPAIGN_RESULT.APPROVER_LABEL' | translate }}</td>
            <td>
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-select [(ngModel)]="approverId">
                        <mat-option
                            *ngFor="let member of members"
                            [value]="member.id + ''"
                        >
                            {{ getFullNamAndEmail(member) }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
        </tr>
    </table>
</div>
<div mat-dialog-actions class="pt-24 pb-24 center">
    <div class="button-wrapper">
        <button
            mat-raised-button
            color="accent"
            (click)="dialogRef.close(getReturnValue())"
        >
            {{ 'CAMPAIGN_RESULT.SEND_BTN' | translate }}
        </button>
        <button
            mat-raised-button
            color="primary"
            class="ml-16"
            (click)="dialogRef.close(false)"
        >
            {{ 'CAMPAIGN_RESULT.CANCEL_BTN' | translate }}
        </button>
    </div>
</div>
